import React from 'react';
import { Button, CircularProgress } from '@mui/material';

import { ReactComponent as DownloadIcon } from 'assets/icons/download-primary.svg';
import { useLocale } from 'hooks/useLocale/useLocale';

import * as Styled from './DownloadTable.styles';
import type { DownloadTableProps } from './DownloadTable.types';

export const DownloadTable: React.FC<DownloadTableProps> = ({ onDownload, isLoading }) => {
  const { formatMessage } = useLocale();

  const handleClick = () => {
    if (onDownload) {
      onDownload();
    }
  };

  return (
    <Styled.DownloadTableContainer>
      <Button
        variant="outlined"
        style={{ whiteSpace: 'nowrap' }}
        onClick={handleClick}
        startIcon={<DownloadIcon />}
        disabled={isLoading}
      >
        {isLoading ? <CircularProgress size={20} /> : formatMessage({ id: 'common.downloadTable' })}
      </Button>
    </Styled.DownloadTableContainer>
  );
};
